const state = {
  show: false,
  phone: null,
};

const mutations = {
  setShow(state, isShow) {
    state.show = isShow;
  },

  setPhone(state, phone) {
    state.phone = phone;
  },
};

const actions = {};

const getters = {
  show(state) {
    return state.show;
  },

  phone(state) {
    return state.phone;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
